export default function Features() {
  return (
    <section className="py-24 px-4 bg-gradient-to-b from-white to-teal-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full text-teal-700 text-sm font-semibold mb-4">
            <i className="ri-star-line"></i>
            <span>Leistungsstarke Features</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Alles was du brauchst,<br />
            um erfolgreich zu sein
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professionelle Tools für jeden Schritt deines Eqology Business
          </p>
        </div>

        {/* Features List */}
        <div className="space-y-16">
          {/* Feature 1: Lead Discovery */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full text-teal-700 text-sm font-semibold mb-4">
                <i className="ri-search-2-line"></i>
                <span>Lead Discovery</span>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Automatische Lead-Generierung mit NEM-Analyse
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Unsere KI durchsucht automatisch Heilberufe in deiner Region und analysiert 
                deren Websites nach bestehenden NEM-Produkten. Du kannst gezielt nach Leads 
                filtern, die noch keine Nahrungsergänzungsmittel anbieten – perfekt für dein 
                Eqology Business.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Google Places Integration für lokale Suche</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Automatische Website-Analyse nach NEM-Produkten</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Erkennung spezifischer Hersteller (Eqology, Zinzino, etc.)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Hunter.io Integration für E-Mail-Recherche</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Filter: Nur Leads ohne NEM für maximales Potenzial</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="aspect-video bg-gradient-to-br from-teal-100 to-emerald-100 rounded-xl flex items-center justify-center">
                <i className="ri-search-eye-line text-teal-600 text-6xl"></i>
              </div>
            </div>
          </div>

          {/* Feature 2: Funnel System */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="aspect-video bg-gradient-to-br from-blue-100 to-cyan-100 rounded-xl flex items-center justify-center">
                  <i className="ri-links-line text-blue-600 text-6xl"></i>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-semibold mb-4">
                <i className="ri-flow-chart"></i>
                <span>Funnel System</span>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Personalisierte Funnels für Social Media
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Erstelle deinen individuellen Funnel-Link und teile ihn auf Instagram, 
                Facebook oder LinkedIn. Interessenten durchlaufen einen professionellen 
                Omega-3 Quiz und werden automatisch als qualifizierte Leads erfasst.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-blue-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Personalisierter Funnel-Link (z.B. /f/dein-name)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-blue-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Professioneller Omega-3 Praxis-Check Quiz</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-blue-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Automatische Lead-Erfassung mit Kontaktdaten</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-blue-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Direkte Integration ins CRM-System</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Feature 3: CRM System */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 rounded-full text-purple-700 text-sm font-semibold mb-4">
                <i className="ri-database-2-line"></i>
                <span>CRM System</span>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Professionelles Lead-Management
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Verwalte alle deine Leads zentral mit einem vollständigen CRM-System. 
                Pipeline-Management, automatische E-Mail-Vorlagen und detaillierte 
                Aktivitäts-Timelines helfen dir, jeden Kontakt optimal zu betreuen.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-purple-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Kanban-Board für Pipeline-Management</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-purple-600 text-xl mt-1"></i>
                  <span className="text-gray-700">NEM-Portfolio-Analyse für jeden Lead</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-purple-600 text-xl mt-1"></i>
                  <span className="text-gray-700">KI-generierte E-Mail-Vorlagen</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-purple-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Aktivitäts-Timeline für jeden Kontakt</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-purple-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Brevo Integration für E-Mail-Versand</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="aspect-video bg-gradient-to-br from-purple-100 to-pink-100 rounded-xl flex items-center justify-center">
                <i className="ri-organization-chart text-purple-600 text-6xl"></i>
              </div>
            </div>
          </div>

          {/* Feature 4: Social Media */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="aspect-video bg-gradient-to-br from-orange-100 to-amber-100 rounded-xl flex items-center justify-center">
                  <i className="ri-instagram-line text-orange-600 text-6xl"></i>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full text-orange-700 text-sm font-semibold mb-4">
                <i className="ri-image-edit-line"></i>
                <span>Social Media</span>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                KI-gestützter Content Generator
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Erstelle professionelle Social Media Posts in Sekunden. Wähle aus 
                vorgefertigten Templates oder generiere individuelle Posts mit KI-Unterstützung 
                – inklusive Bildern, Texten und Hashtags.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                  <span className="text-gray-700">KI Post-Generator für Instagram, Facebook & LinkedIn</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Vorgefertigte Templates nach Kategorien</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Automatische Bild-Generierung mit Stable Diffusion</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Optimierte Hashtags für maximale Reichweite</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Download-Funktion für alle Posts</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
